/**
 * SendEmailInput
 * 
 * @Author: Focci
 * @Date: 2024-09-24 14:49:26
 * @Last Modified by: Focci
 * @Last Modified time: 2024-09-24 14:49:26
 */

import { useTranslations } from 'next-intl'
import { 
  AgentEnquirySimpleButton, AgentEnquirySimpleInput, useAgentEnquirySimple 
} from '@comp/dialog/agent-enquiry/AgentEnquirySimple'

export default function SendEmailInput({ house }) {
  const te = useTranslations('enquiry')
  
  const { inputProps, disabledButton, loading, handleConfirm } = useAgentEnquirySimple({
    house,
    beforeSubmit: (data) => ({
      ...data,
      body: `I am interested in this property ref:${house.code}, and I would like to arrange a private viewing, please send me more information`,
      spec: 'basic',
    })
  })
  
  return (
    <div className="flex flex-col md:flex-row items-center gap-x-2 gap-y-4">
      <AgentEnquirySimpleInput
        placeholder={te('typeEmailOpenhomeEnquiry')}
        className="flex-1 w-full"
        {...inputProps}
      />
      <AgentEnquirySimpleButton
        onClick={handleConfirm}
        disabled={disabledButton}
        className="shrink-0 leading-[1.94] w-full md:w-40 max-w-full"
      >
        {loading ? 'loading...' : te('openhomeEnquiry')}
      </AgentEnquirySimpleButton>
    </div>
  )
}
